<template>
  <el-dialog :class="[currentTheme]" v-dialogDrag:{dialogDrag}=true :title="dialogName" :visible.sync="dialogVisible" :width="dialogWith" :height="dialogHeight" :close-on-click-modal="false" @close='handleCloseDialog' append-to-body>
      <org-page-select ref="pageSelect" v-if="type=='org'"  @confirmMethod="confirmMethod(arguments)" @cancelMethod="handleCloseDialog"></org-page-select>
      <org-multiple-page-select ref="pageSelect" v-if="type=='orgMultiple'"  @confirmMethod="confirmMethod(arguments)" @cancelMethod="handleCloseDialog"></org-multiple-page-select>

      <!-- 选择用户 -->
      <user-page-select ref="pageSelect" v-else-if="type=='user'"  @confirmMethod="confirmMethod(arguments)" @cancelMethod="handleCloseDialog"></user-page-select>
      <user-multiple-page-select ref="pageSelect" v-else-if="type=='userMultiple'"  @confirmMethod="confirmMethod(arguments)" @cancelMethod="handleCloseDialog"></user-multiple-page-select>
      <user-org-multiple-page-select ref="pageSelect" v-else-if="type=='userOrgMultiple'"  @confirmMethod="confirmMethod(arguments)" @cancelMethod="handleCloseDialog"></user-org-multiple-page-select>
      <!-- 选择角色 -->
      <role-page-select ref="pageSelect" v-else-if="type=='role'"  @confirmMethod="confirmMethod(arguments)" @cancelMethod="handleCloseDialog"></role-page-select>
      <role-multiple-page-select ref="pageSelect" v-else-if="type=='roleMultiple'"  @confirmMethod="confirmMethod(arguments)" @cancelMethod="handleCloseDialog"></role-multiple-page-select>

      <!-- 选择菜单 -->
      <menu-multiple-page-select ref="pageSelect" v-else-if="type=='menuMultiple'"  @confirmMethod="confirmMethod(arguments)" @cancelMethod="handleCloseDialog"></menu-multiple-page-select>

      <!-- 选择数据源 -->
      <interface-category-select ref="pageSelect" v-else-if="type=='interfaceCategory'"  @confirmMethod="confirmMethod(arguments)" @cancelMethod="handleCloseDialog"></interface-category-select>
      <!-- 选择页面（代码生成） -->
      <generate-page-select ref="pageSelect" v-else-if="type=='generatePageSelect'"  @confirmMethod="confirmMethod(arguments)" @cancelMethod="handleCloseDialog"></generate-page-select>
      <!-- 选择小区 -->
      <village-multiple-page-select ref="pageSelect" v-else-if="type=='villageMultiple'"  @confirmMethod="confirmMethod(arguments)" @cancelMethod="handleCloseDialog"></village-multiple-page-select>

      <!-- 档案（多选） -->
      <archive-multiple-page-select ref="pageSelect" v-else-if="type=='archiveMultiple'" @confirmMethod="confirmMethod(arguments)" @cancelMethod="handleCloseDialog"></archive-multiple-page-select>
  </el-dialog>
</template>

<script>
  import  RolePageSelect from './core/role/rolePageSelect'
  import  RoleMultiplePageSelect from './core/role/roleMultiplePageSelect'
  import  OrgPageSelect from './core/org/orgPageSelect.vue'
  import  UserPageSelect from './core/user/userPageSelect'
  import  UserMultiplePageSelect from './core/user/userMultiplePageSelect'
  import  UserOrgMultiplePageSelect from './core/user/userOrgMultiplePageSelect'
  import  MenuMultiplePageSelect from './core/menu/menuMultiplePageSelect'
  import  UserMetalPageSelect from "./core/user/userMetalPageSelect";
  import  InterfaceCategorySelect from "./generate/interfaceCategorySelect.vue";
  import  VillageMultiplePageSelect from './core/village/villageMultiplePageSelect.vue'
  import  GeneratePageSelect from './generate/pageSelect.vue'
  import  ArchiveMultiplePageSelect from "./ph/archive/archiveMultiplePageSelect.vue";

  export default {
    name: "pageSelectDialog",
    props: {
      type: String,
      orgType:String
    },
    data (){
      return {
        dialogVisible: false,
        dialogName: '',
        dialogWith: '800px',
        dialogHeight: '800px',
      }
    },
    components: {
      RolePageSelect,
      RoleMultiplePageSelect,
      OrgPageSelect,
      UserPageSelect,
      UserMultiplePageSelect,
      UserOrgMultiplePageSelect,
      MenuMultiplePageSelect,
      UserMetalPageSelect,
      InterfaceCategorySelect,
      VillageMultiplePageSelect,
      GeneratePageSelect,
      ArchiveMultiplePageSelect
    },
    created() {
      this.initWidthAndHeight();
    },
    computed: {
      currentTheme() {
        return this.$store.getters.themeType; //获取当前的主题类型
      },
    },
    methods: {
      init(type, ids, type2, type3, type4) {
        this.dialogVisible = true;
        if(!!type){
          this.type = type;
        }
        this.$nextTick(()=>{
          this.initWidthAndHeight();
          if (this.orgType != null && this.orgType !== ''){
            this.$refs.pageSelect.init(ids, this.orgType, type2, type3, type4); //初始化页面
          }else{
            this.$refs.pageSelect.init(ids, type2, type3, type4); //初始化页面
          }
        })
      },
      //关闭窗口
      handleCloseDialog(){
        this.dialogVisible = false;
        this.$emit('cancelMethod');
      },
      //获取选中的值
      confirmMethod(msg){
        let id = msg[0];
        let name = msg[1];
        this.$emit('confirmMethod',id,name);
        this.dialogVisible = false;
      },
      initWidthAndHeight(){
        if(this.type == 'org'){
          this.dialogName = '单位';
          this.dialogWith = '800px';
          this.dialogHeight = '600px';
        }else if(this.type == 'orgMultiple'){
          this.dialogName = '单位';
          this.dialogWith = '600px';
          this.dialogHeight = '600px';
        }else if(this.type == 'user'){
          this.dialogName = '用户';
          this.dialogWith = '1000px';
          this.dialogHeight = '800px';
        }else if(this.type == 'role'){
          this.dialogName = '角色';
          this.dialogWith = '600px';
          this.dialogHeight = '800px';
        }else if(this.type == 'roleMultiple'){
          this.dialogName = '角色';
          this.dialogWith = '600px';
          this.dialogHeight = '800px';
        }else if(this.type == 'userMultiple'){
          this.dialogName = '用户选择';
          this.dialogWith = '1200px';
          this.dialogHeight = '800px';
        }else if(this.type == 'userOrgMultiple'){
          this.dialogName = '用户选择';
          this.dialogWith = '1500px';
          this.dialogHeight = '800px';
        }else if(this.type == 'interfaceCategory'){
          this.dialogName = '数据源';
          this.dialogWith = '1000px';
          this.dialogHeight = '800px';
        }else if(this.type == 'generatePageSelect'){
          this.dialogName = '页面选择';
          this.dialogWith = '1000px';
          this.dialogHeight = '800px';
        }else if(this.type == 'menuMultiple'){
          this.dialogName = '选择菜单';
          this.dialogWith = '400px';
          this.dialogHeight = '800px';
        }else if(this.type == 'villageMultiple'){
          this.dialogName = '小区选择';
          this.dialogWith = '1000px';
          this.dialogHeight = '800px';
        }else if(this.type == 'archiveMultiple'){
          this.dialogName = '档案选择';
          this.dialogWith = '1000px';
          this.dialogHeight = '800px';
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/PageSelect/pageSelectDialog.vue